import styled, { css } from 'styled-components'

const buttonTypeStyle = ({ disabled }) => {
  if (disabled) {
    return css`
      cursor: not-allowed;
    `
  }

  return css`
    :hover {
      border: none;
      background: rgba(225, 25, 0, 0.05);

      path {
        fill: #E11900;
        fill-opacity: 1;
      }
    }
  `
}

export const SpeciesDetailsHeaderHintWrapper = styled.div`
  width: 100%;
  height: 48px;
  background-color: rgba(32, 32, 32, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: rgba(32, 32, 32, 0.7);
`

export const SpeciesDetailsScientificIconWrapper = styled.div`
  position: relative;
  z-index: 5;

  > svg {
    position: absolute;
    top: -62px;
    right: 16px;
  }
`
export const FullWidthSpecieEstimateItemWrapper = styled.div`
  width: 100%;
`

export const SpeciesDetailsItemWrapper = styled.div`
  width: 416px;
  height: 120px;
  margin: auto 0;
  padding-bottom: 16px;
`
export const SpeciesDetailsIBAItemWrapper = styled.div`
  width: 100%;
  height: 120px;
  margin: auto 0;
  padding-bottom: 16px;
`

export const SpeciesDetailsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: ${(p) => {
    return p.noPadding ? '0px' : '0px 32px'
  }};
  
`

export const SpeciesDetailsAddParameter = styled.div`
  width: 100%;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid rgba(32, 32, 32, 0.1);
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
  margin: 64px 0;
  color: #0aa1f4;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  cursor: ${(p) => {
    return p.disabled ? 'not allowed' : 'pointer'
  }};
  pointer-events: ${(p) => {
    return p.disabled ? 'none' : ''
  }};

  > svg {
    margin-right: 8px;
  }

  path {
    fill: #0aa1f4;
  }
`
export const SpeciesDetailsRemoveParameter = styled.div`
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  border-radius: 4px;
  border: 1px solid rgba(32, 32, 32, 0.2);
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
  margin-left: 16px;
  margin-top: 8px;
  cursor: pointer;
  ${buttonTypeStyle}
`

export const SpeciesDetailsParameterIdContainer = styled.div`
  display: flex;
  align-items: center;
`

export const SpeciesDetailsParameterIdWrapper = styled.div`
  width: 352px;
  height: 120px;
`

export const SpeciesValidationIconWrapper = styled.div`
  position: relative;
  left: 0;

`
export const SpeciesValidationIcon = styled.div`
  position: absolute;
`

export const SpeciesAcordionWrapper = styled.div`
  margin: 8px 112px;
`

export const SpeciesAssessmentStyleWrapper = styled.div` 
  margin-top: 64px;
`

export const SpecieParameterToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 0.7)'
  }};
  gap: 8px;

  path {
    fill: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32)'
  }};
    fill-opacity: ${(p) => {
    return p.isActive ? '1' : '0.5'
  }};
  }

  :hover {
    color: rgba(10, 161, 244, 1);

    path {
      fill-opacity: 1;
      fill: rgba(10, 161, 244, 1);
    }
  }
`
export const NewSiteHeaderNotification = styled.div`
  height: 40px;
  width: 100%;
  position: sticky;
  padding: 0 32px;
  top: 72px;
  left: 0;
  background: #202020;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  z-index: 6;
  margin: 0;

  path {
    fill: #FFFFFF;
  }

  div {
    cursor: pointer;
  }
`
export const HeaderNotificationCalendarText = styled.span`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  margin: 0 8px;
`
